import React from 'react';
import { NDivider } from 'nayan';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <section className="bg-card flex flex-col justify-center text">
      <NDivider />
      <div className="container mx-auto">
        <div className="grid md:grid-cols-8 col-span-3 gap-12 pb-3 pt-5">
          <div className="md:col-span-3 col-span-1">
            <div className="text-base text-text mb-2">ABOUT KIDSTER</div>
            <div className="text-sm leading-8">
              Kidster is a fun and engaging smart learning app designed for kids, featuring pictorial learning, interactive stories, brain-boosting
              puzzles, and educational games. It offers a playful environment that makes learning enjoyable, helping children develop essential skills
              through visuals and interactive content.
            </div>
          </div>
          <div className="col-span-1" />
          <div className="md:col-span-2 col-span-1">
            <div className="text-base text-text mb-2">QUICK LINKS</div>
            <ul className="text-text text-sm m-0 list-none">
              <li className="leading-9 cursor-pointer">
                <Link to="/" className="text-text hover:text-primary no-underline py-2.5">
                  About Us
                </Link>
              </li>
              <li className="leading-9 cursor-pointer">
                <Link to="/terms-of-use" className="text-text hover:text-primary no-underline py-2.5">
                  Terms of Use
                </Link>
              </li>
              <li className="leading-9 cursor-pointer">
                <Link to="/privacy-policy" className="text-text hover:text-primary no-underline py-2.5">
                  Privacy Policy
                </Link>
              </li>
              <li className="leading-9 cursor-pointer">
                <Link to="/delete-account" className="text-text hover:text-primary no-underline py-2.5">
                  Delete Account
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2 col-span-1">
            <div className="text-base text-text mb-2">CONTACT US</div>
            <div className="text-sm leading-8">
              <strong>Address:</strong> &nbsp;Bangalore, India.
            </div>
            <div className="text-sm leading-8 mb-2">
              <strong>Email:</strong> &nbsp;
              <a className="text-text" href="mailto:hello@worklage.com" target="_blank">
                hello@worklage.com
              </a>
            </div>
            <div className="text-sm leading-8 mb-2">
              <strong>Mobile:</strong> &nbsp;
              <a className="text-text" href="tel:+919620209040" target="_blank">
                +919620209040
              </a>
            </div>
          </div>
        </div>
        <NDivider />
        <div className="md:flex justify-between items-center py-3">
          <div className="text-sm text text-center md:mb-0 mb-2">All Rights Reserved © {new Date().getFullYear()}</div>
          <div className="text-sm text text-center">
            Powered by{' '}
            <Link to="/" className="text-primary font-semibold no-underline" aria-label="Worklage Technologies">
              Worklage Technologies
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
